import {gql} from "@apollo/client";

export const UpdateProfile = gql`
    mutation UpdateProfile($input: ProfileUpdateAttributesInput!) {
        updateProfile(input: $input) {
            id
            language
        }
    }
`;
